export const jobs = [
  {
    company: "9M Holdings Inc",
    url: "https://9mholdings.com",
    position: "Co-founder & Head of Design",
    date: "2024 - Present",
    city: "San Francisco",
    country: "CA",
    description: "Leading design and product development for innovative fintech solutions. Responsible for design system architecture, brand identity, and full-stack implementation using React and TypeScript.",
    logo: "",
  },
  {
    company: "Salesgrid.io",
    url: "https://salesgrid.io",
    position: "Design Engineer",
    date: "2025",
    city: "Remote",
    country: "",
    description: "Contract role focused on building modern sales tools with emphasis on interface design and frontend architecture.",
    logo: "",
  },
  {
    company: "resumate.dev",
    url: "https://resumate.dev",
    position: "Product Designer",
    date: "2024",
    city: "Remote",
    country: "",
    description: "Designed and prototyped AI-powered resume building platform with focus on user experience and conversion optimization.",
    logo: "",
  },
  {
    company: "2M.trading",
    url: "",
    position: "Frontend Developer",
    date: "2024 - 2025",
    city: "Remote",
    country: "",
    description: "Developed trading platform interfaces with real-time data visualization and responsive design patterns.",
    logo: "",
  },
  {
    company: "Self-employed",
    url: "",
    position: "Freelance Framer Developer",
    date: "2024 - Present",
    city: "San Francisco",
    country: "CA",
    description: "Creating custom websites and prototypes using Framer, specializing in animation-rich experiences and modern design implementations.",
    logo: "",
  },
  {
    company: "Self-employed",
    url: "",
    position: "Freelance Video Editor",
    date: "2022 - 2024",
    city: "San Francisco",
    country: "CA",
    description: "Video editing and motion graphics work for various clients, developing skills in visual storytelling and motion design.",
    logo: "",
  },
];
